import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Mail05 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "mail05",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m13.744 2.6336 7.528 4.8932c.266.1729.399.2594.4954.3747a.9999.9999 0 0 1 .1884.3473C22 8.3924 22 8.551 22 8.8683V16.2c0 1.6802 0 2.5202-.327 3.162a2.9994 2.9994 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a2.9997 2.9997 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2V8.8683c0-.3173 0-.4759.0442-.6195a1 1 0 0 1 .1885-.3473c.0963-.1154.2293-.2018.4953-.3747l7.528-4.8932m3.488 0c-.6313-.4103-.9469-.6155-1.287-.6953a2 2 0 0 0-.914 0c-.3401.0798-.6557.285-1.287.6953m3.488 0 6.1921 4.0249c.6879.447 1.0318.6707 1.1509.9541a1 1 0 0 1 0 .7748c-.1191.2835-.463.507-1.1509.9541l-6.1921 4.0249c-.6313.4103-.9469.6155-1.287.6953a1.9986 1.9986 0 0 1-.914 0c-.3401-.0798-.6557-.285-1.287-.6953L4.0639 9.3415c-.6879-.447-1.0318-.6706-1.151-.9541a1 1 0 0 1 0-.7748c.1192-.2834.4631-.507 1.151-.9541l6.1921-4.025M21.5 19l-6.6428-6m-5.7144 0L2.5 19"
    })
  }));
};
export default Mail05;